/* THIS IS A GENERATED FILE, DO NOT EDIT */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AccountBulkUpdatePaymentPrefsResponseOrError": [
      "AccountBulkUpdatePaymentPrefsResponse",
      "AccountBulkUpdatePaymentPrefsValidationErrors",
      "MutationErrorResponse"
    ],
    "ActivateGlobalUserResponse": [
      "ActivateGlobalUserObject",
      "MutationErrorResponse"
    ],
    "ActivityFeedObjectType": [
      "CalendarEventObjectType",
      "CapitalCallObjectType",
      "DistributionObjectType",
      "EmailObjectType",
      "NetIncomeObjectType",
      "NoteObjectType",
      "StoredEmailObjectType",
      "TransactionObjectType"
    ],
    "AddressObjectTypeBase": [
      "AddressObjectType",
      "ContactAddressObjectType",
      "UserAddressObjectType"
    ],
    "ArenaStyleSettingsResponseOrError": [
      "ArenaStyleSettingsMutationResponse",
      "MutationErrorResponse"
    ],
    "AssetReportTemplateModuleFieldOrError": [
      "AssetReportTemplateModuleFieldObjectType",
      "MutationErrorResponse"
    ],
    "AssetReportTemplateModuleFieldsResponse": [
      "AssetReportTemplateModuleFieldResults",
      "MutationErrorResponse"
    ],
    "AssetReportTemplateModuleResponseOrError": [
      "AssetReportTemplateModuleObjectType",
      "MutationErrorResponse"
    ],
    "AssetReportTemplateResponseOrError": [
      "AssetReportTemplateObjectType",
      "MutationErrorResponse"
    ],
    "AsyncJobOrError": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "BulkUpdateAccountResponseOrError": [
      "BulkUpdateAccountResponse",
      "MutationErrorResponse"
    ],
    "CanopyGroupUsersResponse": [
      "CanopyGroupUsersOutput",
      "MutationErrorResponse"
    ],
    "CashflowHistoryItem": [
      "CashflowHistoryDeltaItem",
      "CashflowHistoryDistributionItem",
      "CashflowHistoryTransactionItem"
    ],
    "ClearPortalUserNewLinkedArenasResponse": [
      "ClearPortalUserNewLinkedArenasObject",
      "MutationErrorResponse"
    ],
    "CommonCompanyInvestorDataInterface": [
      "LLCPartnershipInvestorDataObjectType",
      "TrustInvestorDataObjectType"
    ],
    "ConfirmNewEmailResponse": [
      "ConfirmNewEmailObject",
      "MutationErrorResponse"
    ],
    "ContactActivityFeedObjectType": [
      "CalendarEventObjectType",
      "EmailObjectType",
      "NoteObjectType",
      "StoredEmailObjectType"
    ],
    "ContactDeleteConfirmationObjectTypeOrError": [
      "ContactDeleteConfirmationObjectType",
      "MutationErrorResponse"
    ],
    "ContactDeletedCountObjectTypeOrError": [
      "ContactDeletedCountObjectType",
      "MutationErrorResponse"
    ],
    "ContactObjectTypeOrError": [
      "ContactObjectType",
      "MutationErrorResponse"
    ],
    "CreateDocumentVersionResponse": [
      "DocumentVersionObjectType",
      "MutationErrorResponse"
    ],
    "CreateFolderDocumentsResponse": [
      "FolderDocumentResults",
      "MutationErrorResponse"
    ],
    "CreateLpConsolidationResponse": [
      "LpConsolidationRequestObject",
      "MutationErrorResponse"
    ],
    "CreateProspectsObjectTypeOrError": [
      "CreateProspectsAsyncResponse",
      "CreateProspectsObjectType",
      "MutationErrorResponse"
    ],
    "CreateStoredEmailResponse": [
      "StoredEmailAlreadyExistsResponse",
      "StoredEmailObjectType"
    ],
    "DataRoomByDataRoomKey": [
      "DataRoomAccessNdaRequiredObjectType",
      "DataRoomAccreditationRequiredObjectType",
      "DataRoomDetailsObjectType",
      "DataRoomNoAccessObjectType",
      "DataRoomRedirectObjectType"
    ],
    "DatetimeFormatPreferencesResponse": [
      "MutationErrorResponse",
      "UpdateDatetimeFormatPreferencesObject"
    ],
    "DeleteAssetLocationResponse": [
      "DeleteAssetLocationObject",
      "MutationErrorResponse"
    ],
    "DeleteAssetResponse": [
      "DeleteAssetObject",
      "MutationErrorResponse"
    ],
    "DeleteFieldAccessRoleResponse": [
      "DeleteFieldAccessRoleObject",
      "MutationErrorResponse"
    ],
    "DeleteFolderDocumentResponse": [
      "FolderDocument",
      "MutationErrorResponse"
    ],
    "DeleteFolderResponse": [
      "DocumentFolder",
      "MutationErrorResponse"
    ],
    "DiligenceDataObjectType": [
      "IndividualDiligenceDataObjectType",
      "InstitutionDiligenceDataObjectType"
    ],
    "DocumentEnrichment": [
      "HTMLWatermarkEnrichment",
      "PasswordProtectionEnrichment"
    ],
    "DocumentParentObjectType": [
      "AccountObjectType",
      "OfferingObjectType",
      "PositionObjectType",
      "ProspectObjectType"
    ],
    "DocumentResponse": [
      "DocumentNDASignatureRequiredResponse",
      "DocumentObjectType",
      "DocumentPortalActivationRequiredResponse"
    ],
    "DowngradeStaffOrHybridUserToEmail2FAResponse": [
      "DowngradeStaffOrHybridUserToEmail2FAObject",
      "MutationErrorResponse"
    ],
    "DownloadDataRoomDocumentsResponse": [
      "DocumentLoginOrNDASignatureRequiredResponse",
      "DownloadDataRoomDocumentsObject",
      "MutationErrorResponse"
    ],
    "DownloadFolderContentsResponse": [
      "DocumentLoginOrNDASignatureRequiredResponse",
      "DownloaderFolderContentObjectType",
      "MutationErrorResponse",
      "SingleDocumentDownloadResponse"
    ],
    "DownloadSubscriptionDocumentsResponse": [
      "DownloadSubscriptionDocumentsObject",
      "MutationErrorResponse"
    ],
    "EditArenaResponse": [
      "EditArenaObject",
      "MutationErrorResponse"
    ],
    "EditDataRoomConfigurationSettingsResponseOrError": [
      "EditDataRoomConfigurationSettingsResponse",
      "MutationErrorResponse"
    ],
    "EditFolderDocumentsResponse": [
      "FolderDocument",
      "MutationErrorResponse"
    ],
    "EditorTemplateOrError": [
      "EditorTemplateObjectType",
      "MutationErrorResponse"
    ],
    "EditUserLookerViewResponse": [
      "EditUserLookerViewObject",
      "MutationErrorResponse"
    ],
    "EmailAddressObjectTypeBase": [
      "ContactEmailAddressObjectType"
    ],
    "EmailAttachmentObjectType": [
      "DocumentObjectType",
      "RestrictedDocumentObjectType"
    ],
    "EmailBatchOrError": [
      "EmailBatchObjectType",
      "MutationErrorResponse"
    ],
    "EmailContent": [
      "EmailBatchObjectType",
      "InstantiatedEmailObjectType"
    ],
    "EnvelopeDetails": [
      "ESignatureEntityEnvelopeDetails",
      "ESignatureOfferingEnvelopeDetails",
      "SubscriptionEmbeddedEnvelopeDetails"
    ],
    "ESignatureRequestObjectObjectType": [
      "AccountObjectType",
      "OfferingObjectType"
    ],
    "ESignatureRequestRecipientObjectObjectType": [
      "PositionObjectType",
      "ProspectObjectType"
    ],
    "ExportContactsOrError": [
      "ExportContactsObject",
      "MutationErrorResponse"
    ],
    "FolderDocumentOrError": [
      "FolderDocument",
      "FolderDocumentError"
    ],
    "GenerateTotpQrCodeResponse": [
      "GenerateTotpQrCodeOutput",
      "MutationErrorResponse"
    ],
    "GridViewObjectTypeOrError": [
      "GridViewObjectType",
      "MutationErrorResponse"
    ],
    "ImportContactsOrError": [
      "ImportContactsObject",
      "MutationErrorResponse"
    ],
    "InvestmentLinkedObject": [
      "AssetObjectType",
      "PositionObjectType"
    ],
    "InvestmentObjectType": [
      "InvestmentGroupInfo",
      "InvestmentTreeNode"
    ],
    "InvestorDataObjectType": [
      "AccountObjectType",
      "IndividualInvestorDataObjectType",
      "LLCPartnershipInvestorDataObjectType",
      "TrustInvestorDataObjectType"
    ],
    "InvestorDiligenceObjectObjectType": [
      "AccountObjectType",
      "ContactObjectType",
      "SubscriptionObjectType"
    ],
    "LoginResponse": [
      "LoginConfigurationRequiredResponse",
      "LoginObject",
      "LoginPasswordResetResponse",
      "LoginStaffEmailUpgradeRequiredResponse",
      "LoginVerificationRequiredResponse",
      "MutationErrorResponse"
    ],
    "ManageObjectGroupMembershipBulkObjectTypeOrError": [
      "ManageObjectGroupMembershipBulkObjectType",
      "MutationErrorResponse"
    ],
    "MatchAndShareDocumentCollectionResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "MutationSuccessOrErrorResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "Node": [
      "CurrencyObjectType"
    ],
    "NodeWithProfitLoss": [
      "AccountObjectType"
    ],
    "NodeWithTimeSeries": [
      "AccountObjectType",
      "AssetAcquisitionObjectType",
      "AssetObjectType",
      "LoanObjectType"
    ],
    "NoteOrError": [
      "MutationErrorResponse",
      "NoteObjectType"
    ],
    "ObjectDocuments": [
      "AccountObjectType",
      "OfferingObjectType"
    ],
    "ObjectLevelEditPermissions": [
      "AccountObjectType",
      "AssetObjectType",
      "LoanObjectType",
      "PositionObjectType"
    ],
    "ObjectValueObjectType": [
      "AccountObjectType",
      "EntityCollectionObjectType",
      "UserObjectType"
    ],
    "OfferingFolderObjectType": [
      "DocumentFolder",
      "PortalLoginRedirectObjectType"
    ],
    "ParseSpreadsheetResponse": [
      "MutationErrorResponse",
      "ParseSpreadsheetObject"
    ],
    "PaymentPrefUnionObjectType": [
      "AchPaymentPrefObjectType",
      "BacsPaymentPrefObjectType",
      "BecsPaymentPrefObjectType",
      "CheckPaymentPrefObjectType",
      "EftPaymentPrefObjectType",
      "NonUsPaymentPrefObjectType",
      "SepaPaymentPrefObjectType",
      "WirePaymentPrefObjectType"
    ],
    "PermissionCheckedNode": [
      "AccountContactLabelGroupObjectType",
      "AccountContactMapObjectType",
      "AccountObjectType",
      "ActivityTypeObjectType",
      "ArenaObjectType",
      "ArenaSettingsObjectType",
      "AssetAcquisitionObjectType",
      "AssetDispositionObjectType",
      "AssetLoanMapObjectType",
      "AssetObjectType",
      "AssetReportTemplateModuleFieldObjectType",
      "AssetReportTemplateModuleObjectType",
      "AssetReportTemplateObjectType",
      "AsyncJobObjectType",
      "BankAccountObjectType",
      "CalendarEventObjectType",
      "CapitalCallBatchObjectType",
      "CapitalCallBatchTotalObjectType",
      "CapitalCallDetailObjectType",
      "CapitalCallObjectType",
      "ComplianceSettingsObjectType",
      "ContactObjectType",
      "ContactPhotoObjectType",
      "ContactRelationKeyPersonType",
      "ContactRelationLabelObjectType",
      "ContactRelationObjectType",
      "CountryObjectType",
      "DataRoomMetricLabelObjectType",
      "DataRoomMetricObjectType",
      "DataRoomObjectType",
      "DistributionBatchObjectType",
      "DistributionBatchTotalObjectType",
      "DistributionDetailObjectType",
      "DistributionObjectType",
      "DistributionTypeObjectType",
      "DocumentCategoryObjectType",
      "DocumentFolder",
      "DocumentObjectType",
      "DocumentShareObjectType",
      "DocumentUpload",
      "DocumentVersionObjectType",
      "DocumentViewObjectType",
      "DocumentWatermarkObjectType",
      "EditionObjectType",
      "EditorTemplateObjectMapObjectType",
      "EditorTemplateObjectType",
      "EmailBatchObjectType",
      "EmailDistributionListObjectType",
      "EmailObjectType",
      "EmailRecipientObjectType",
      "EntityCollectionObjectType",
      "EntitySubTypeObjectType",
      "ESignatureDocumentObjectType",
      "ESignatureExecutedDocumentObjectType",
      "ESignatureGpSignerObjectType",
      "ESignatureLpSignerObjectType",
      "ESignatureRequestBatchObjectType",
      "ESignatureRequestObjectType",
      "ESignatureRequestRecipientObjectType",
      "ESignatureRequestTemplateErrorObjectType",
      "ESignatureRequestTemplateGpSignerObjectType",
      "ESignatureRequestTemplateObjectType",
      "ExtensionFieldEnumObjectType",
      "ExtensionFieldObjectType",
      "ExtensionFieldValueObjectType",
      "FeatureFlagEnumValueObjectType",
      "FeatureFlagObjectType",
      "FeatureFlagOwnerObjectType",
      "FieldAccessFieldObjectType",
      "FieldAccessPermissionsObjectType",
      "FolderDocument",
      "GroupObjectType",
      "ImportTemplateObjectType",
      "InvestorDiligenceCommentObjectType",
      "InvestorDiligenceEmailObjectType",
      "InvestorDiligenceObjectType",
      "InvestorGroupObjectType",
      "KycDetailObjectType",
      "KycDocumentObjectType",
      "KycDocumentVersionActivityObjectType",
      "KycDocumentVersionObjectType",
      "LabelDisplaySettingsObjectType",
      "LabelDisplayVariantObjectType",
      "LeadObjectType",
      "LeadSourceObjectType",
      "LoanMetricObjectType",
      "LoanMetricPeriodObjectType",
      "LoanMetricPeriodValueObjectType",
      "LoanObjectType",
      "LocationObjectType",
      "LpAccessRoleGrantObjectType",
      "LpAccessRoleObjectType",
      "LpAccessRoleScopeObjectType",
      "ManagementFeeBatchObjectType",
      "ManagementFeeDetailObjectType",
      "ManagementFeeObjectType",
      "ManagementFeeTypeGroupObjectType",
      "ManagementFeeTypeObjectType",
      "ManagerObjectType",
      "NavBatchObjectType",
      "NavBatchTotalObjectType",
      "NavDetailObjectType",
      "NavObjectType",
      "NavTypeObjectType",
      "NdaObjectType",
      "NetIncomeBatchObjectType",
      "NetIncomeBatchTotalObjectType",
      "NetIncomeDetailObjectType",
      "NetIncomeObjectType",
      "NetIncomeTypeObjectType",
      "NoteObjectType",
      "NotificationCampaignObjectType",
      "ObjectGroupObjectObjectType",
      "ObjectGroupObjectType",
      "OfferingObjectType",
      "OperatingCompanyDetailsObjectType",
      "OwnershipUnitObjectType",
      "ParallelEntityObjectType",
      "PastEmploymentObjectType",
      "PaymentBatchObjectType",
      "PaymentObjectType",
      "PaymentPermissionType",
      "PaymentPrefObjectType",
      "PendingStoredEmailObjectType",
      "PerformanceMetricsObjectType",
      "PhotoObjectType",
      "PortalHeroMetricsConfigObjectType",
      "PortalHeroMetricsObjectType",
      "PortalInvitationJobObjectType",
      "PositionAcmMapObjectType",
      "PositionDeltaObjectType",
      "PositionObjectType",
      "PostEngagementObjectType",
      "PostObjectType",
      "PostSharingSettingsObjectType",
      "ProductTypeAndSizeObjectType",
      "ProspectContactMapObjectType",
      "ProspectObjectType",
      "PublicationObjectType",
      "ReportTemplateAllocationTypeMapObjectType",
      "ReportTemplateAllocationTypeObjectType",
      "ReportTemplateObjectType",
      "RoleObjectType",
      "SessionLogObjectType",
      "SsoConfigObjectType",
      "StateCBSAObjectType",
      "StateObjectType",
      "StationeryObjectType",
      "StoredEmailObjectType",
      "SubscriptionObjectType",
      "SubscriptionReviewerObjectType",
      "SubscriptionReviewerSettingObjectType",
      "TagObjectType",
      "TaxDocDeliveryPrefObjectType",
      "TransactionBatchObjectType",
      "TransactionBatchTotalObjectType",
      "TransactionDetailObjectType",
      "TransactionObjectType",
      "TransactionTypeObjectType",
      "TwrPeriodMetricObjectType",
      "UnitValueBatchObjectType",
      "UnitValueMetricObjectType",
      "UnitValueObjectType",
      "UploadTransactionFileObjectType",
      "UserLookerViewObjectType",
      "UserNotificationFrequencyObjectType",
      "UserObjectType",
      "UserPromptViewedObjectType",
      "WatchlistScreeningDetailObjectType",
      "WatchlistScreeningLogObjectType",
      "WaterfallObjectType"
    ],
    "PhoneObjectTypeBase": [
      "ContactPhoneObjectType",
      "UserPhoneObjectType"
    ],
    "PhotoInterface": [
      "ContactPhotoObjectType",
      "PhotoObjectType"
    ],
    "PublicationOrError": [
      "MutationErrorResponse",
      "PublicationObjectType"
    ],
    "Question": [
      "FreeFormQuestion",
      "MultipleChoiceQuestion"
    ],
    "RegardingObjectType": [
      "AccountObjectType",
      "CalendarEventObjectType",
      "ContactObjectType",
      "LeadObjectType",
      "OfferingObjectType",
      "PositionObjectType",
      "ProspectObjectType"
    ],
    "ResetPasswordRequestResponseOrError": [
      "MutationErrorResponse",
      "ResetPasswordRequestResponse"
    ],
    "ResetPasswordResponseOrError": [
      "MutationErrorResponse",
      "ResetPasswordResponse"
    ],
    "SendEmailAddressVerificationResponse": [
      "MutationErrorResponse",
      "SendEmailAddressVerificationObject"
    ],
    "SetGlobalPortalLoginCookiesResponse": [
      "MutationErrorResponse",
      "SetGlobalPortalLoginCookiesObject"
    ],
    "SettingsAddTaskResponseOrError": [
      "MutationErrorResponse",
      "SettingsAddTaskResponse"
    ],
    "StaffActivationDetailsResponse": [
      "StaffActivationDetailsObject",
      "StaffActivationTokenInvalidObject"
    ],
    "SubscriptionAccountInfoObjectType": [
      "IndividualInvestorDataObjectType",
      "LLCPartnershipInvestorDataObjectType",
      "TrustInvestorDataObjectType"
    ],
    "SubscriptionAccountObjectType": [
      "SubscriptionAccountEntityObjectType",
      "SubscriptionAccountIndividualObjectType",
      "SubscriptionAccountJointObjectType",
      "SubscriptionAccountTrustObjectType"
    ],
    "SubscriptionContactOrErrorResponse": [
      "MutationErrorResponse",
      "SubscriptionContactObjectType"
    ],
    "SubscriptionCounterpartyOrErrorResponse": [
      "MutationErrorResponse",
      "SubscriptionCounterpartyObjectType"
    ],
    "SubscriptionOrErrorResponse": [
      "MutationErrorResponse",
      "SubscriptionV2ObjectType"
    ],
    "SubscriptionRedirectUrlByDataRoomKey": [
      "SubscriptionRedirectUrlError",
      "SubscriptionRedirectUrlObject"
    ],
    "TaggableObjectType": [
      "AccountObjectType",
      "ContactObjectType"
    ],
    "TimeSeriesFieldWrapperObjectType": [
      "TimeSeriesDateObjectType",
      "TimeSeriesFloatObjectType",
      "TimeSeriesIntObjectType",
      "TimeSeriesRangeObjectType",
      "TimeSeriesStringObjectType",
      "TimeSeriesWalletObjectType"
    ],
    "ToggleAiEnabledResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "TransactionDescriptionResponse": [
      "TransactionDescriptionNotFoundResponse",
      "TransactionDescriptionObjectType"
    ],
    "TransactionInstanceBatchObjectType": [
      "CapitalCallBatchObjectType",
      "DistributionBatchObjectType",
      "ManagementFeeBatchObjectType",
      "NavBatchObjectType",
      "NetIncomeBatchObjectType",
      "TransactionBatchObjectType",
      "UnitValueBatchObjectType"
    ],
    "TransactionTotalsObjectTypeBase": [
      "PositionMetricsObjectType",
      "TransactionTotalsObjectType"
    ],
    "TwoStepAuthSendResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "TwrPeriodMetricDetailsObjectType": [
      "TwrPeriodMetricPortalObjectType",
      "TwrPeriodMetricStaffObjectType"
    ],
    "UnauthenticatedAcceptNdaResponse": [
      "MutationErrorResponse",
      "NdaObjectType"
    ],
    "UnauthenticatedUpdateTaxDocDeliveryPrefResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "UndeleteFolderDocumentResponse": [
      "FolderDocument",
      "MutationErrorResponse"
    ],
    "UndeleteFolderResponse": [
      "DocumentFolder",
      "MutationErrorResponse"
    ],
    "UnifiedPortalActivationDetailsResponse": [
      "UnifiedPortalActivationDetails",
      "UnifiedPortalActivationError"
    ],
    "UnifiedPortalDocumentActivationDetailsResponse": [
      "UnifiedPortalActivationError",
      "UnifiedPortalDocumentActivationDetailsObject",
      "UnifiedPortalDocumentActivationRedirectObject"
    ],
    "UnifiedPortalUnauthTermsAndPolicyResponse": [
      "UnifiedPortalUnauthTermsAndPolicyError",
      "UnifiedPortalUnauthTermsAndPolicyObject"
    ],
    "UpdatedContactIdsOrError": [
      "MutationErrorResponse",
      "UpdatedContactIdsObjectType"
    ],
    "UpdateFolderSharingSettingsResponse": [
      "DocumentFolder",
      "MutationErrorResponse"
    ],
    "UpdateGlobalUserResponse": [
      "MutationErrorResponse",
      "UpdateGlobalUserObject"
    ],
    "UpdateSubscriptionReviewDecisionResponse": [
      "MutationErrorResponse",
      "UpdateSubscriptionReviewDecisionObject"
    ],
    "UpdateUserTwoFaResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "UpsertFolderResponse": [
      "DocumentFolder",
      "MutationErrorResponse"
    ],
    "VerifyPasswordResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "VerifyTwoFaCodeResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ]
  }
};
      export default result;
    